import { WithdrawFlowInitialValues } from '../../types/bank-account'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { formatDecimal } from '../../utils/withdraw-helpers'

export interface useWithdrawProps {
  fetcher: (id: string) => Promise<any>
}

export const useWithdraw = (
  id: string | undefined,
  payload: WithdrawFlowInitialValues,
  code: string
) => {
  const url: string = 'producer/analytics/createWithdrawRequest'

  const useWithdrawFetcher = async () => {
    const nWithdrawMoney = payload.withdrawMoney.replace(',', '.')
    const formattedWithdrawMoney = formatDecimal(nWithdrawMoney)
    payload.withdrawMoney = formattedWithdrawMoney
    return await APIDecoratorWithBaseURI().post(url, {
      params: {
        eventId: id,
        ...payload,
        code2FA: code.toString(),
      },
    })
  }

  return {
    useWithdrawFetcher,
  }
}
